/* Court Vibes: Reihenfolge der teeinblue-Knoepfe (Farbe, Groesse).
   teeinblue sortiert Farben alphabetisch und Groessen teils falsch.
   Groessen: feste Rangfolge (XS bis 5XL, Zahlen aufsteigend).
   Farben: Reihenfolge wie in Shopify (Weiss zuerst laut Checkliste).
   Es wird nur CSS order gesetzt, die DOM-Reihenfolge bleibt unangetastet. */
(function () {
  if (window.cvTeeSort) return;
  window.cvTeeSort = true;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var R = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];
  function rank(v) {
    v = (v || '').trim().toUpperCase().replace(/\s/g, '');
    if (v === '2XL') v = 'XXL';
    var i = R.indexOf(v);
    if (i > -1) return i;
    var n = parseFloat(v);
    return isNaN(n) ? 1000 : 100 + n;
  }
  var P = null;
  // teeinblue waehlt beim Laden seine eigene erste Farbe (alphabetisch, z. B.
  // Anthrazit) und schreibt sie in die Adresse. Kam der Besucher OHNE
  // ?variant= auf die Seite, wird einmalig die erste Shopify-Farbe gewaehlt,
  // also die, die auch auf der Kachel zu sehen war (z. B. Natur beim Beutel).
  // Die urspruengliche Adresse kommt aus dem Navigationseintrag, weil teeinblue
  // location.search zu diesem Zeitpunkt schon umgeschrieben haben kann.
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  var startUrl = nav ? nav.name : location.href;
  var vorwahl = !/[?&]variant=/.test(startUrl);
  function erstWahl(box, vals) {
    if (!vorwahl || !/tee-option--color/.test(box.className)) return;
    var an = box.querySelector('input:checked');
    if (!an) return;
    vorwahl = false;
    if (an.value === vals[0]) return;
    var ziel = Array.prototype.filter.call(box.querySelectorAll('input'), function (i) { return i.value === vals[0]; })[0];
    if (!ziel) return;
    var lab = ziel.id ? box.querySelector('label[for="' + ziel.id + '"]') : null;
    (lab || ziel).click();
  }
  function apply() {
    document.querySelectorAll('.tee-option').forEach(function (box) {
      var inner = box.querySelector('.tee-option-inner');
      if (!inner) return;
      var size = /tee-option--size/.test(box.className);
      var vals = null;
      if (!size) {
        if (!P || !P.options) return;
        var t = ((box.querySelector('.tee-option__title') || {}).textContent || '').trim().toLowerCase();
        for (var j = 0; j < P.options.length; j++) {
          if ((P.options[j].name || '').trim().toLowerCase() === t) { vals = P.options[j].values; break; }
        }
        if (!vals) return;
      }
      // teeinblue gibt dem letzten Knopf im DOM keinen Abstand nach rechts.
      // Nach dem Umsortieren steht er mitten in der Reihe und klebt am
      // Nachbarn, deshalb bekommt er den Abstand der anderen Knoepfe.
      var mr = '';
      Array.prototype.forEach.call(inner.children, function (el) {
        if (!mr && el.querySelector('input')) { var x = getComputedStyle(el).marginRight; if (x !== '0px') mr = x; }
      });
      Array.prototype.forEach.call(inner.children, function (el, idx) {
        var inp = el.querySelector('input');
        if (!inp) return;
        var ord;
        if (size) ord = rank(inp.value);
        else { var k = vals.indexOf(inp.value); ord = k > -1 ? k : 500 + idx; }
        if (el.style.order !== String(ord)) el.style.order = ord;
        if (mr && el.style.marginRight !== mr && getComputedStyle(el).marginRight === '0px') el.style.marginRight = mr;
      });
      if (!size) erstWahl(box, vals);
    });
  }
  var q = false;
  function later() { if (q) return; q = true; requestAnimationFrame(function () { q = false; apply(); }); }
  fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) { P = p; later(); }).catch(function () {});
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
  later();
})();
